<div class="w-full min-h-[100dvh] text-gray-900 flex flex-col">
  <div class="fixed inset-0 pointer-events-none select-none opacity-50 -z-10">
    <svg
      viewBox="0 0 1680 1373"
      preserveAspectRatio="xMidYMid slice"
      xmlns="http://www.w3.org/2000/svg"
      class="w-full h-full"
    >
      <path
        d="M894.499 1667H10.3878C-119.782 1667 -226 1560.98 -226 1431.05V559.999C-226 237.774 32.2563 -31.4402 348.829 -40.7952C510.239 -44.9529 662.277 14.295 777.867 126.554C878.879 225.301 940.319 353.151 953.856 491.397C1248.56 525.698 1480.78 771.005 1484.95 1068.28C1487.03 1228.36 1426.63 1378.04 1315.21 1492.37C1203.78 1604.63 1053.83 1667 894.499 1667ZM365.49 144.225C361.325 144.225 358.201 144.225 354.035 144.225C136.392 150.461 -39.5972 336.521 -39.5972 558.96V1430.01C-39.5972 1458.07 -16.6875 1480.94 11.4292 1480.94H894.499C1003.84 1480.94 1106.94 1438.32 1184 1360.37C1261.06 1282.41 1301.67 1179.5 1300.63 1070.36C1297.5 872.87 1147.55 709.678 953.856 677.456C942.401 851.042 899.706 1030.86 761.206 1170.15C585.216 1345.81 370.697 1314.63 248.858 1194.06C128.061 1073.48 96.8204 858.318 272.81 682.653C412.351 543.369 598.754 501.791 767.454 490.357C754.957 403.044 713.303 321.968 648.739 258.563C571.679 184.763 471.709 144.225 365.49 144.225ZM766.412 676.416C596.671 689.929 485.246 732.546 404.02 813.622C310.298 907.172 323.836 1005.92 380.069 1062.05C409.227 1091.15 446.716 1106.74 486.288 1106.74C534.19 1106.74 583.134 1082.84 628.953 1038.14C710.179 958.104 752.875 845.845 766.412 676.416Z"
        fill="url(#paint0_radial)"
      ></path>
      <defs>
        <radialGradient
          id="paint0_radial"
          cx="0"
          cy="0"
          r="1"
          gradientTransform="matrix(-1240.52 -4.83701 1584.21 -2298.78 741.285 378.583)"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#F1E3FF"></stop>
          <stop offset="1" stop-color="#F3E7FF"></stop>
        </radialGradient>
      </defs>
    </svg>
  </div>

  <app-desktop-header
    active="settings"
    (sectionSelect)="onHeaderSectionSelect($event)"
  ></app-desktop-header>

  <div class="sticky top-0 bg-white z-10 md:hidden">
    <div class="relative flex items-center justify-center py-4 md:py-6">
      <button
        class="absolute left-3 p-2 rounded hover:bg-gray-100"
        aria-label="Back"
        (click)="handleBack()"
      >
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M15 19l-7-7 7-7"
          />
        </svg>
      </button>
      <div class="font-semibold">Settings</div>
    </div>
    <div
      class="h-[1px] bg-gradient-to-r from-purple-200/40 via-purple-200/60 to-purple-200/20"
    ></div>
  </div>

  <div
    class="flex-1 px-3 pt-4 md:px-32 md:pt-8 flex flex-col md:space-y-0"
    [ngClass]="
      whatsappAboutOpen
        ? ''
        : 'md:grid md:grid-cols-[360px_minmax(0,1fr)] md:gap-6'
    "
  >
    <div
      *ngIf="!whatsappAboutOpen"
      class="space-y-2 md:space-y-0 flex flex-col gap-2 h-full md:sticky md:top-8 md:self-start md:flex"
      [class.hidden]="showProfile || showSubscription || showWhatsapp"
    >
      <button class="w-full text-left" (click)="openProfile()">
        <div
          class="flex items-center gap-3 rounded-2xl p-4 transition-colors border"
          [ngClass]="
            showProfile
              ? 'bg-[#2F2A4A] border-[#2F2A4A] shadow-md text-white'
              : 'bg-white border-gray-200 shadow-sm'
          "
        >
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M18.125 9.5H17.5V7C17.5 4.2425 15.2575 2 12.5 2C9.7425 2 7.5 4.2425 7.5 7V9.5H6.875C5.84167 9.5 5 10.3408 5 11.375V20.125C5 21.1592 5.84167 22 6.875 22H18.125C19.1583 22 20 21.1592 20 20.125V11.375C20 10.3408 19.1583 9.5 18.125 9.5ZM9.16667 7C9.16667 5.16167 10.6617 3.66667 12.5 3.66667C14.3383 3.66667 15.8333 5.16167 15.8333 7V9.5H9.16667V7ZM13.3333 15.935V17.8333C13.3333 18.2933 12.9608 18.6667 12.5 18.6667C12.0392 18.6667 11.6667 18.2933 11.6667 17.8333V15.935C11.1708 15.6458 10.8333 15.1142 10.8333 14.5C10.8333 13.5808 11.5808 12.8333 12.5 12.8333C13.4192 12.8333 14.1667 13.5808 14.1667 14.5C14.1667 15.1142 13.8292 15.6458 13.3333 15.935Z"
              fill="#C389FD"
            />
          </svg>
          <div class="flex-1">
            <div class="text-sm font-extrabold tracking-wide">ACCOUNT</div>
            <div
              class="text-sm"
              [ngClass]="showProfile ? 'text-white' : 'text-gray-500'"
            >
              Your data and settings
            </div>
          </div>
          <svg
            class="w-5 h-5"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            [ngClass]="showProfile ? 'text-[#2E294E]' : 'text-gray-400'"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M9 5l7 7-7 7"
            />
          </svg>
        </div>
      </button>

      <button
        class="w-full text-left"
        (click)="openSubscription()"
        [attr.aria-current]="showSubscription ? 'page' : null"
      >
        <div
          class="flex items-center gap-3 rounded-2xl p-4 transition-colors border"
          [ngClass]="
            showSubscription
              ? 'bg-[#2F2A4A] border-[#2F2A4A] shadow-md text-white'
              : 'bg-white border-gray-200 shadow-sm'
          "
        >
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M11.1866 22.691V20.276C10.3893 20.184 9.69164 19.9847 9.09364 19.678C8.49564 19.356 7.98964 18.9803 7.57564 18.551C7.17698 18.1217 6.86264 17.654 6.63264 17.148C6.41798 16.6267 6.28764 16.1207 6.24164 15.63L8.81764 14.917C8.87898 15.5763 9.09364 16.1897 9.46164 16.757C9.84498 17.3243 10.42 17.7 11.1866 17.884V13.652L10.7726 13.56C9.54598 13.284 8.57998 12.7933 7.87464 12.088C7.16931 11.3827 6.81664 10.4627 6.81664 9.328C6.81664 8.76067 6.92398 8.224 7.13864 7.718C7.35331 7.212 7.65231 6.75967 8.03564 6.361C8.43431 5.947 8.90198 5.60967 9.43864 5.349C9.97531 5.08833 10.558 4.912 11.1866 4.82V2.382H13.3026V4.843C13.9773 4.95033 14.56 5.142 15.0506 5.418C15.5413 5.694 15.9553 6.00833 16.2926 6.361C16.63 6.71367 16.8906 7.097 17.0746 7.511C17.274 7.90967 17.412 8.30067 17.4886 8.684L15.0046 9.466C14.974 9.29733 14.9203 9.11333 14.8436 8.914C14.7823 8.69933 14.6826 8.49233 14.5446 8.293C14.4066 8.07833 14.238 7.88667 14.0386 7.718C13.8393 7.534 13.594 7.38833 13.3026 7.281V11.398L13.5096 11.444C14.8896 11.7507 15.9246 12.3027 16.6146 13.1C17.3046 13.882 17.6496 14.7867 17.6496 15.814C17.6496 16.3353 17.5576 16.8413 17.3736 17.332C17.1896 17.8227 16.9136 18.2673 16.5456 18.666C16.1776 19.0647 15.7176 19.4097 15.1656 19.701C14.629 19.977 14.008 20.161 13.3026 20.253V22.691H11.1866ZM9.50764 9.167C9.50764 9.581 9.63798 9.95667 9.89864 10.294C10.1746 10.616 10.604 10.8383 11.1866 10.961V7.189C10.6346 7.327 10.213 7.58 9.92164 7.948C9.64564 8.316 9.50764 8.72233 9.50764 9.167ZM14.9816 15.952C14.9816 15.538 14.8436 15.17 14.5676 14.848C14.307 14.526 13.8853 14.2807 13.3026 14.112V17.884C13.8853 17.7613 14.307 17.5237 14.5676 17.171C14.8436 16.803 14.9816 16.3967 14.9816 15.952Z"
              fill="#C389FD"
            />
          </svg>
          <div class="flex-1">
            <div class="text-sm font-extrabold tracking-wide">SUBSCRIPTION</div>
            <div
              class="text-sm"
              [ngClass]="showSubscription ? 'text-white' : 'text-gray-500'"
            >
              {{
                userService.isSubscribed
                  ? "Subscription is active"
                  : "No active subscription"
              }}
            </div>
          </div>
          <svg
            class="w-5 h-5"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            [ngClass]="showSubscription ? 'text-[#2E294E]' : 'text-gray-400'"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M9 5l7 7-7 7"
            />
          </svg>
        </div>
      </button>

      <button
        class="w-full text-left"
        (click)="openWhatsapp()"
        [attr.aria-current]="showWhatsapp ? 'page' : null"
      >
        <div
          class="flex items-center gap-3 rounded-2xl p-4 transition-colors border"
          [ngClass]="
            showWhatsapp
              ? 'bg-[#2F2A4A] border-[#2F2A4A] shadow-md text-white'
              : 'bg-white border-gray-200 shadow-sm'
          "
        >
          <svg
            width="24"
            height="22"
            viewBox="0 0 24 22"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g clip-path="url(#wapp-icon-clip)">
              <path
                d="M1.46913 10.8696C1.46862 12.718 1.95537 14.5229 2.88091 16.1137L1.38062 21.549L6.98649 20.0906C8.53701 20.9281 10.2742 21.3669 12.0396 21.3671H12.0443C17.8721 21.3671 22.6161 16.6615 22.6186 10.8778C22.6197 8.07523 21.5208 5.43984 19.5241 3.45711C17.5278 1.47455 14.8727 0.382138 12.0438 0.380859C6.21529 0.380859 1.47154 5.08613 1.46913 10.8696Z"
                fill="white"
              />
              <path
                d="M1.09195 10.8649C1.09135 12.7799 1.59555 14.6493 2.55409 16.2971L1 21.9273L6.80688 20.4165C8.40687 21.2821 10.2083 21.7385 12.0413 21.7391H12.0461C18.083 21.7391 22.9974 16.8644 23 10.8736C23.001 7.97031 21.8625 5.24018 19.7945 3.18642C17.7263 1.13291 14.9763 0.0011938 12.0461 0C6.00809 0 1.09436 4.87411 1.09195 10.8649ZM4.55016 16.0133L4.33334 15.6718C3.42189 14.2337 2.94081 12.572 2.9415 10.8656C2.94339 5.88619 7.02748 1.83504 12.0495 1.83504C14.4815 1.83606 16.7671 2.77677 18.4862 4.48356C20.2052 6.19053 21.1511 8.45959 21.1505 10.8729C21.1483 15.8524 17.0641 19.904 12.0461 19.904H12.0425C10.4085 19.9032 8.80605 19.4678 7.40853 18.645L7.07595 18.4493L3.63003 19.3458L4.55016 16.0133Z"
                fill="#C389FD"
              />
              <path
                d="M9.30831 6.32225C9.10326 5.87005 8.88747 5.86093 8.69248 5.853C8.53281 5.84618 8.35027 5.84669 8.16792 5.84669C7.98538 5.84669 7.68881 5.91482 7.43813 6.18641C7.1872 6.45825 6.4801 7.11518 6.4801 8.4513C6.4801 9.78742 7.46091 11.0788 7.59763 11.2601C7.73453 11.4412 9.4911 14.2708 12.2731 15.3594C14.5851 16.264 15.0556 16.0841 15.5574 16.0387C16.0593 15.9935 17.1768 15.382 17.4048 14.7478C17.633 14.1137 17.633 13.5702 17.5646 13.4566C17.4962 13.3435 17.3136 13.2755 17.0399 13.1398C16.7662 13.004 15.4205 12.3469 15.1697 12.2563C14.9187 12.1657 14.7363 12.1205 14.5538 12.3925C14.3712 12.664 13.8471 13.2755 13.6873 13.4566C13.5278 13.6382 13.368 13.6608 13.0944 13.5249C12.8205 13.3887 11.939 13.1023 10.8933 12.1771C10.0796 11.4573 9.53028 10.5683 9.37061 10.2964C9.21094 10.0249 9.35351 9.87772 9.49075 9.74239C9.61373 9.62071 9.76455 9.42527 9.90153 9.26675C10.038 9.10815 10.0835 8.99499 10.1748 8.81387C10.2662 8.63259 10.2204 8.47398 10.1521 8.33815C10.0835 8.20231 9.55168 6.8592 9.30831 6.32225Z"
                fill="#C389FD"
              />
            </g>
            <defs>
              <clipPath id="wapp-icon-clip">
                <rect
                  width="22"
                  height="22"
                  fill="white"
                  transform="translate(1)"
                />
              </clipPath>
            </defs>
          </svg>
          <div class="flex-1">
            <div class="text-sm font-extrabold tracking-wide">
              CONNECT WHATSAPP
            </div>
            <div
              class="text-sm"
              [ngClass]="showWhatsapp ? 'text-white' : 'text-gray-500'"
            >
              {{ whatsapp.connectedNumber || "No connected number" }}
            </div>
          </div>
          <svg
            class="w-5 h-5"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            [ngClass]="showWhatsapp ? 'text-[#2E294E]' : 'text-gray-400'"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M9 5l7 7-7 7"
            />
          </svg>
        </div>
      </button>

      <!-- My data lives in the desktop header; on mobile it's reached from this menu -->
      <button class="w-full text-left md:hidden" (click)="openMyData()">
        <div class="flex items-center gap-3 rounded-2xl border border-gray-200 bg-white p-4 shadow-sm transition-colors">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M16.4926 8C16.7729 8.00018 17 8.22442 17 8.50041C16.9998 8.77625 16.7728 8.99982 16.4926 9H6.50736C6.22723 8.99982 6.00018 8.77625 6 8.50041C6 8.22442 6.22712 8.00018 6.50736 8H16.4926Z" fill="#C389FD" />
            <path d="M13.467 12C13.7614 12.0002 14 12.2244 14 12.5004C13.9998 12.7762 13.7613 12.9998 13.467 13H6.53299C6.23871 12.9998 6.00019 12.7762 6 12.5004C6 12.2244 6.23859 12.0002 6.53299 12H13.467Z" fill="#C389FD" />
            <path d="M16.4926 16C16.7729 16.0002 17 16.2244 17 16.5004C16.9998 16.7762 16.7728 16.9998 16.4926 17H6.50736C6.22723 16.9998 6.00018 16.7762 6 16.5004C6 16.2244 6.22712 16.0002 6.50736 16H16.4926Z" fill="#C389FD" />
            <path d="M17.45 19.8097V21H5.55V19.8097H17.45ZM18.8097 18.45V6.55C18.8097 5.79889 18.2011 5.19033 17.45 5.19033H5.55C4.79889 5.19033 4.19033 5.79889 4.19033 6.55V18.45C4.19033 19.2011 4.79889 19.8097 5.55 19.8097V21L5.41885 20.9967C4.07147 20.9284 3 19.8143 3 18.45V6.55C3 5.14167 4.14167 4 5.55 4H17.45C18.8583 4 20 5.14167 20 6.55V18.45C20 19.8583 18.8583 21 17.45 21V19.8097C18.2011 19.8097 18.8097 19.2011 18.8097 18.45Z" fill="#C389FD" />
          </svg>
          <div class="flex-1">
            <div class="text-sm font-extrabold tracking-wide">MY DATA</div>
            <div class="text-sm text-gray-500">Health reports</div>
          </div>
          <svg class="h-5 w-5 text-gray-400" viewBox="0 0 24 24" fill="none" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7" />
          </svg>
        </div>
      </button>

      <!-- Promo: Track your cycle through WhatsApp. Only while no number is
           connected — once WhatsApp is on, the list ends at the three cards. -->
      <div
        *ngIf="!whatsapp.isConnected"
        class="md:mt-4 bg-white border border-[#DAD6FB] rounded-[20px] px-5 py-8 flex flex-col items-start gap-5 shadow-sm"
      >
        <svg
          width="56"
          height="56"
          viewBox="0 0 32 32"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M16 3C8.82 3 3 8.82 3 16c0 2.29.6 4.53 1.74 6.5L3 29l6.66-1.73A12.9 12.9 0 0 0 16 29c7.18 0 13-5.82 13-13S23.18 3 16 3Z"
            fill="#25D366"
          />
          <path
            d="M10.1 9.5c-.28 0-.73.1-1.11.52-.38.42-1.46 1.43-1.46 3.48 0 2.06 1.5 4.04 1.71 4.32.21.28 2.95 4.5 7.16 6.15.99.38 1.77.61 2.38.79.99.31 1.9.27 2.62.16.8-.12 2.46-1.01 2.81-1.98.35-.97.35-1.8.24-1.98-.1-.17-.38-.28-.8-.49-.42-.21-2.46-1.22-2.85-1.35-.38-.14-.66-.21-.94.21-.28.42-1.08 1.35-1.32 1.63-.24.28-.49.31-.9.1-.42-.21-1.76-.65-3.35-2.07-1.24-1.1-2.07-2.46-2.32-2.88-.24-.42-.02-.64.19-.85.19-.19.42-.49.63-.73.21-.24.28-.42.42-.7.14-.28.07-.52-.03-.73-.1-.21-.94-2.28-1.31-3.11-.34-.81-.69-.7-.94-.71-.24-.01-.52-.01-.8-.01Z"
            fill="#fff"
          />
        </svg>

        <p class="text-3xl font-bold text-black leading-tight tracking-tight">
          Track <span class="italic text-[#B6A8F7]">your cycle</span> through
          WhatsApp!
        </p>

        <p class="text-base text-black leading-6">
          Stay on top of your cycle
          <span class="font-bold">without having to open a tracking app</span>.
          Receive important cycle updates, log symptoms in seconds, and chat
          with your personal Health Assistant—<span class="font-bold"
            >all in WhatsApp</span
          >.
        </p>

        <ul class="w-full flex flex-col gap-4">
          <li class="flex items-start gap-2">
            <svg
              class="w-5 h-5 shrink-0 text-[#857AEF]"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
            >
              <circle cx="12" cy="12" r="9" stroke-width="1.5" />
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M8.5 12.5l2.5 2.5 4.5-5"
              />
            </svg>
            <span class="text-sm text-black"
              >Never miss an important cycle update</span
            >
          </li>
          <li class="flex items-start gap-2">
            <svg
              class="w-5 h-5 shrink-0 text-[#857AEF]"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
            >
              <circle cx="12" cy="12" r="9" stroke-width="1.5" />
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M8.5 12.5l2.5 2.5 4.5-5"
              />
            </svg>
            <span class="text-sm font-bold text-black"
              >Log symptoms in seconds—right from WhatsApp</span
            >
          </li>
          <li class="flex items-start gap-2">
            <svg
              class="w-5 h-5 shrink-0 text-[#857AEF]"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
            >
              <circle cx="12" cy="12" r="9" stroke-width="1.5" />
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M8.5 12.5l2.5 2.5 4.5-5"
              />
            </svg>
            <span class="text-sm text-black"
              >Personalized answers
              <span class="font-bold">whenever you need them</span></span
            >
          </li>
          <li class="flex items-start gap-2">
            <svg
              class="w-5 h-5 shrink-0 text-[#857AEF]"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
            >
              <circle cx="12" cy="12" r="9" stroke-width="1.5" />
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M8.5 12.5l2.5 2.5 4.5-5"
              />
            </svg>
            <span class="text-sm font-bold text-black"
              >The first cycle tracker that lives in your chat.</span
            >
          </li>
        </ul>

        <button
          (click)="openWhatsapp()"
          class="self-center bg-black text-white rounded-full px-8 py-3 text-xs tracking-[0.15em] font-bold shadow-[0_4px_0_0_rgba(0,0,0,0.1)] active:translate-y-[2px] active:shadow-[0_6px_0_0_rgba(0,0,0,0.1)]"
        >
          CONNECT YOUR NUMBER
        </button>
      </div>
    </div>

    <div class="md:col-start-2 md:relative">
      <div *ngIf="showProfile" class="animate-slide-in-x">
        <app-profile></app-profile>
      </div>
      <div *ngIf="showSubscription" class="animate-slide-in-x">
        <app-subscription-details></app-subscription-details>
      </div>
      <div *ngIf="showWhatsapp" class="animate-slide-in-x">
        <app-connect-whatsapp
          (aboutOpenChange)="onWhatsappAboutOpenChange($event)"
        ></app-connect-whatsapp>
      </div>
    </div>
  </div>

  <app-desktop-footer class="mt-8"></app-desktop-footer>

  <!-- Footer/Mobile - Figma node 25769:269457 -->
  <footer class="md:hidden mt-8 flex w-full flex-col gap-[38px]">
    <div class="flex flex-col items-start gap-3 px-5 text-sm leading-[18px]">
      <a
        class="text-black hover:underline"
        href="https://legal.stringhealth.ai/privacy-policy.html"
        target="_blank"
        rel="noopener"
        >Privacy policy</a
      >
      <a
        class="text-black hover:underline"
        href="https://legal.stringhealth.ai/terms-of-use.html"
        target="_blank"
        rel="noopener"
        >Terms and Conditions</a
      >
      <button type="button" class="text-[#5D38F1] underline" (click)="logout()">
        Logout
      </button>
    </div>

    <div
      class="flex h-[34px] w-full items-center justify-between bg-white px-5 py-[5px]"
    >
      <svg
        class="block h-4 w-[45px]"
        viewBox="0 0 69 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        role="img"
        aria-label="IVY"
      >
        <path d="M6.20154 24H0V0H6.20154V24Z" fill="black" />
        <path
          d="M25.1055 17.8392L33.3004 0H39.7677L28.1177 24H21.8276L10.2218 0H16.9106L25.1055 17.8392Z"
          fill="black"
        />
        <path
          d="M51.8129 13.9126L40.8716 0H48.0476L55.0908 9.51199L62.134 0H69L57.9258 13.9126V24H51.8129V13.9126Z"
          fill="black"
        />
      </svg>
      <span class="text-xs leading-[18px] text-[#8B8C91]"
        >Health Assistant v{{ appVersion }}</span
      >
    </div>
  </footer>
</div>
